<video #video [poster]="thumb" controls></video>